export const LESSON_REVIEW_IFRAME_PARENT = (lessonId: string) => `lesson-review-player_${lessonId}`;
